import { render, staticRenderFns } from "./ImportUploader.vue?vue&type=template&id=381f833c&scoped=true&"
import script from "./ImportUploader.vue?vue&type=script&lang=js&"
export * from "./ImportUploader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381f833c",
  null
  
)

export default component.exports